/**
 * Re-initializes third-party financing widgets after AJAX section updates.
 * Affirm and PayTomorrow initialize once on page load and do not observe
 * DOM changes from the Section Rendering API / morph pipeline.
 */

/** @type {Record<string, unknown>} */
const PAYTOMORROW_OPTIONS = {
  debugMode: false,
  enableMoreInfoLink: true,
  logoColor: 'original',
  maxAmount: 6500.0,
  maxTerm: 24,
  minAmount: 300.0,
  mpeSelector: '.mpe',
  priceSelector: '.price',
  storeDisplayName: '',
  prefixString: '',
  postfixString: '',
  primeHasZero: false,
  appendSelector: '.mpe',
  priceDelimiter: '',
  publicId: 'd154c0f8daa15898e78b755db74e9a39',
  displayMicroOffers: false,
  displayPrimeOffers: false,
  maxMicroAmount: 500.0,
  primeApr: 0.0,
};

/**
 * Affirm appends `.affirm-as-low-as`
 * @param {ParentNode} root
 */
function refreshAffirm(root) {
  if (typeof insertAlaMessages === 'function') {
    root.querySelectorAll('.affirm-as-low-as').forEach((el) => el.remove());
    insertAlaMessages();
    return;
  }

  if (!window.affirm?.ui?.ready) return;
  window.affirm.ui.ready(() => window.affirm.ui.refresh());
}

/**
 * PayTomorrow appends `.pt-mpe-container` as a sibling after `.mpe`, not inside it.
 * @param {Element} mpe
 */
function isPayTomorrowInitialized(mpe) {
  return mpe.nextElementSibling?.classList.contains('pt-mpe-container') ?? false;
}

/**
 * @param {ParentNode} root
 */
function refreshPayTomorrow(root) {
  if (!window.PayTomorrow?.mpeInit) return;

  const targets = [...root.querySelectorAll('.mpe')].filter((el) => !isPayTomorrowInitialized(el));
  if (!targets.length) return;

  window.PayTomorrow.mpeInit(PAYTOMORROW_OPTIONS);
}

/**
 * @param {ParentNode} [root=document]
 */
export function refreshFinancingWidgets(root = document) {
  refreshAffirm(root);
  refreshPayTomorrow(root);
}
